import React from "react"
import Loadable from '@loadable/component'
import {useStaticQuery, graphql} from "gatsby"

const LineChart = () => {
const data = useStaticQuery(graphql`
    {
      allAllCities5YCsv {
        edges {
          node {
            date
            orlando
            longbeach
            seattle
            washington
          }
        }
      }
    }
  `);

const datapoints = data.allAllCities5YCsv.edges;


const date_data = Object.keys(datapoints).map(key => datapoints[key].node.date);
const longbeach_data =  Object.keys(datapoints).map(key => datapoints[key].node.longbeach);
const washington_data = Object.keys(datapoints).map(key => datapoints[key].node.washington);
const orlando_data = Object.keys(datapoints).map(key => datapoints[key].node.orlando);
const seattle_data = Object.keys(datapoints).map(key => datapoints[key].node.seattle);
  return (
<>
<LoadableChart
options={{
  dataLabels: {enabled: false},
  title: {
    text: '2019 Temperature'
  },
  legend: {position: 'top',},
  chart: {
    id: "basic-line"
  },
  xaxis: {
      title: {
    text: 'Date'
  },
    categories: date_data,
    type: "datetime"
  },
    yaxis: {
      title: {
    text: 'Temperature (in Fahrenheit)'
  },
      min:10,
    }
}}
series={[
  {
    name: "Long Beach",
    data: longbeach_data
  }, {
    name: "Washington DC",
    data: washington_data
  }, {
    name: "Orlando",
    data: orlando_data
  }, {
    name: "Seattle",
    data: seattle_data
  },

]}
type="line"

/>
</>)
};

export default LineChart

// import react-apexcharts here
const LoadableChart = Loadable(() => import('../../node_modules/react-apexcharts/src/react-apexcharts'));
